/*global REACT_APP_API_BASE_URL_NEW:true*/
import { RoleType } from "@/utils/enum";
import request from "@/utils/request";
import { cleanObjectFromUndefined } from "@/utils/utils";

export async function getAllAdminUsers({
  page = 1,
  pageSize = 10,

  city,
  stateId,
  verified,
  hasTWIC,
  hasEModal,
  isActive,
  filter = "",
  roleId,
  organizationUnitId,
  userName,
  phoneNumber,
  email,
  firstName,
  lastName,
  isLockedOut,
  notActive,
  emailConfirmed,
  isExternal,
  maxCreationTime,
  minCreationTime,
  maxModificationTime,
  minModificationTime,
  sorting,
}) {
  page--;
  const SkipCount = page * pageSize;
  let Sorting;

  if (typeof sorting === "string" && sorting.indexOf(":") !== -1) {
    const [sortBy, sortOrder] = sorting.split(":");
    Sorting = `${sortBy} ${sortOrder}`;
  }

  const params = cleanObjectFromUndefined({
    SkipCount,
    MaxResultCount: pageSize,

    City: city,
    StateId: stateId,
    Verified: verified,
    Twic: hasTWIC,
    EModal: hasEModal,
    Active: isActive,
    Filter: filter || undefined,
    RoleId: roleId,
    OrganizationUnitId: organizationUnitId,
    UserName: userName,
    PhoneNumber: phoneNumber,
    Email: email,
    Name: firstName,
    Surname: lastName,
    IsLockedOut: isLockedOut,
    NotActive: notActive,
    EmailConfirmed: emailConfirmed,
    IsExternal: isExternal,
    MaxCreationTime: maxCreationTime,
    MinCreationTime: minCreationTime,
    MaxModifitionTime: maxModificationTime,
    MinModifitionTime: minModificationTime,
    Sorting,
  });

  try {
    const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/users/admin`, {
      method: "GET",
      params,
    });
    return result?.data;
  } catch (error) {
    return {
      items: [],
      totalCount: 0,
    };
  }
}

export async function createNewAdminUser(data) {
  data = {
    ...data,
    type: RoleType.Admin,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/users/admin`, {
    method: "POST",
    data,
  });
  return result?.data;
}

export async function getAdminUserById(userId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/users/admin/${userId}`, {
    method: "GET",
  });

  return result?.data;
}

export async function updateAdminUser(userId, data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/users/admin`, {
    method: "PUT",
    params: { id: userId },
    data,
  });

  if ("error" in result) {
    throw new Error(result.error.message);
  }

  return result.data;
}

export async function updateProfilePhoto({ userId, profilePhotoUri }) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/users/${userId}/profile-photo`, {
    method: "PATCH",
    params: {
      profilePhotoUri,
    },
  });

  return result?.data;
}
export async function getAdminManagers({ filter = undefined }) {
  const params = cleanObjectFromUndefined({
    FilterText: filter,
  });

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/users/managers`, {
    method: "GET",
    params,
  });

  return result?.data;
}
